'use client';

import { useEffect } from 'react';
import { useOrganizationTheme } from '@/hooks/useOrganizationTheme';

/**
 * Provider que aplica dinámicamente los colores de la organización
 * a las variables CSS del tema
 */
export function OrganizationThemeProvider({ children }: { children: React.ReactNode }) {
  const { shouldApplyOrganizationColor, colorVariations } = useOrganizationTheme();

  useEffect(() => {
    const root = document.documentElement;

    if (shouldApplyOrganizationColor) {
      // Aplicar el color primario de la organización
      root.style.setProperty('--primary', colorVariations.primary);
      root.style.setProperty('--ring', colorVariations.ring);
      root.style.setProperty('--chart-1', colorVariations.chart1);
      root.style.setProperty('--sidebar-primary', colorVariations.sidebarPrimary);
      root.style.setProperty('--sidebar-ring', colorVariations.sidebarRing);
      
      // Establecer valores RGB para usar con opacidad
      if (colorVariations.primaryRgb) {
        const { r, g, b } = colorVariations.primaryRgb;
        root.style.setProperty('--primary-rgb', `${r}, ${g}, ${b}`);
      }
    } else {
      // Restaurar los colores por defecto
      root.style.removeProperty('--primary');
      root.style.removeProperty('--ring');
      root.style.removeProperty('--chart-1');
      root.style.removeProperty('--sidebar-primary');
      root.style.removeProperty('--sidebar-ring');
      root.style.removeProperty('--primary-rgb');
    }

    // Cleanup: restaurar valores por defecto cuando el componente se desmonte
    return () => {
      if (!shouldApplyOrganizationColor) {
        root.style.removeProperty('--primary');
        root.style.removeProperty('--ring');
        root.style.removeProperty('--chart-1');
        root.style.removeProperty('--sidebar-primary');
        root.style.removeProperty('--sidebar-ring');
        root.style.removeProperty('--primary-rgb');
      }
    };
  }, [shouldApplyOrganizationColor, colorVariations]);

  return <>{children}</>;
}

